import {
    useCallback,
    useMemo,
} from 'react'
import omit from 'lodash/omit'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    REDIRECT_PARAM,
} from 'app/shared-components/SkyNetTable/hooks/useAddCopiedItemWorkaround'
import {
    PricingStatus,
} from 'app/enums/label.enums'
import idRemover from 'app/utils/idRemover'

import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import AlLogisticPricingRequests from 'app/requests/AirlineLogisticPricing.requests'
import WarningCard from 'app/shared-components/WarningCard'
import AlLogisticPricingForm from '../AlLogisticPricingForm'
import useGetAlLogisticPricing from '../hooks/useGetAlLogisticPricing'

type Props = {
    id: number
}

const AlLogisticPricingCopy = ({
    id,
}: Props) => {
    const {
        AlLogisticPricing: AlLogisticPricingRoutes,
    } = usePricingRoutes()
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetAlLogisticPricing(id)

    const onSuccess = useCallback(({
        id: copyId,
    }) => {
        invalidate()
        AlLogisticPricingRoutes.Update.navigate({
            params: {
                key: copyId,
            },
            options: {
                state: REDIRECT_PARAM,
            },
        })
    }, [
        AlLogisticPricingRoutes,
        invalidate,
    ])
    const modifyDataBeforeSend = useCallback((newData) => {
        return {
            ...omit(newData, [
                'id',
                'status',
            ]),
            deliveryCollectionFees: newData.deliveryCollectionFees
                && idRemover(newData.deliveryCollectionFees),
            otherFees: newData.otherFees && idRemover(newData.otherFees),
        }
    }, [])

    const value = useMemo(() => {
        return {
            ...data,
            status: PricingStatus.IN_PROGRESS,
        }
    }, [data])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <WarningCard>
                    You are deep copying a Al Logistic Pricing.
                </WarningCard>
                <AlLogisticPricingForm
                    data={value}
                    modifyDataBeforeSend={modifyDataBeforeSend}
                    onSuccess={onSuccess}
                    requestParam={AlLogisticPricingRequests.create()}
                />
            </>

        </StatusHandler>
    )
}

export default AlLogisticPricingCopy
